import {
  Box,
  Dialog,
  styled,
  TableCell,
  Tab,
  Tabs,
  Grid,
  Typography,
  Divider as MuiDivider,
} from '@mui/material';

export const MainContainer = styled(Grid)(({ theme }) => ({
  padding: '8px 24px 24px',
  backgroundColor: theme.palette.background.default,
}));

export const ThreatCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: '16px',
  marginTop: '16px',
  borderRadius: '16px',
  ...(theme.palette.mode === 'dark'
    ? { boxShadow: 'none', border: `1px solid ${theme.palette.divider}` }
    : { boxShadow: '0px 18px 32px 16px rgba(193, 193, 193, 0.16)' }
  ),
}));

import { StyledTabProps, StyledTabsProps } from '../../../helpers/types';
import { Button } from '../../../components';

export const ImageStyle = {
  width: 480,
  height: 'auto',
  cursor: 'pointer',
};

export const ThreatNameStyled = styled(ThreatCard)(({ theme }) => ({


}));


export const StatusButtonWrapper = styled(Box)({
  marginTop: '8px',
  display: 'flex',
  gap: '8px'
});

export const SummaryTable = styled(Box)(({ theme }) => ({
  padding: '16px',
  marginTop: '8px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

export const TableWrapper = styled(ThreatCard)({
  marginTop: '16px',
});

export const ExternalToolListWrapper = styled(Box)({
  width: '100%',
  flexWrap: 'wrap',
  display: 'flex',
  gap: '8px',
});

export const TabsLoaderWrapper = styled(Box)({
  width: '100%',
  justifyContent: 'center',
  display: 'flex',
  margin: '60px 0',
});

export const WhoisLoaderWrapper = styled(Box)({
  width: '100%',
  height: '70vh',
  justifyContent: 'center',
  display: 'flex',
  alignItems: 'center',
});

export const NoDataWrapper = styled(Box)({
  width: '100%',
  justifyContent: 'center',
  display: 'flex',
  margin: '60px 0',
});

export const PaginationStyle = styled(Box)({
  display: 'flex',
  justifyContent: 'right',
  margin: '12px 0',
});

export const SingleThreatLoaderWrapper = styled(Box)({
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  height: '100vh',
});

export const NoteLabelWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '10px'
});

export const CheckboxStyle = {
  padding: '4px',
  '&.Mui-checked': {
    color: 'primary.main',
  },
};

export const FormControlLabelStyle = {
  padding: '0 6px',
  '& .MuiTypography-root': { fontSize: '14px' },
};

export const ScreenshotWrapper = styled(ThreatCard)({
  alignItems: 'center',
  gap: '10px',
  marginTop: '16px',
});

export const CompleteTakedowntDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    height: 'auto',
    width: 530,
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(4),
  },
  '& .MuiDialogContentText-root': {
    color: theme.palette.text.primary,
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(0),
    marginTop: '20px',
    justifyContent: 'end',
    display: 'flex',
  },
}));

export const TakedownTable = styled(Box)(({ theme }) => ({
  marginTop: '6px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

export const TableHeaderCell = styled(TableCell)(({ theme }) => ({
  background: theme.palette.background.tertiary,
  color: theme.palette.text.primary,
  fontWeight: 'bold',
}));

export const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: <span className="MuiTabs-indicatorSpan" />,
    }}
  />
))({
  '& .MuiTabs-indicator': {
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-flexContainer': {
    justifyContent: 'space-between',
    marginRight: '8%',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 0,
  },
});

export const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  color: theme.palette.primary.main,
  '&.Mui-selected': {
    color: theme.palette.text.primary,
  },
}));

export const ButtonsStyle = styled(Box)({
  display: 'flex',
  justifyContent: 'end',
  width: '100%',
  margin: '10px 0 26px',
});

export const CreatedByLabel = styled(Box)({
  display: 'flex',
  gap: '24px',
  justifyContent: 'end',
  marginTop: '6px',
});

export const LinesStyle = {
  margin: '6px 0',
};

export const EditCommentsIconStyle = {
  height: 22,
  marginRight: '6px',
  marginLeft: '6px',
};

export const PrivateLabel = styled(Typography)(({ theme }) => ({
  background: theme.palette.primary.main,
  borderRadius: '4px',
  color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.common.white,
  height: 'fit-content',
  padding: '4px 10px',
  fontSize: 11,
}));

export const PublicLabel = styled(Typography)(({ theme }) => ({
  background: theme.palette.success.main,
  borderRadius: '4px',
  color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.common.white,
  height: 'fit-content',
  padding: '4px 10px',
  fontSize: 11,
}));

export const CommentsWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '-webkit-fill-available',
});

export const EditModeWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
});

export const UpdateButton = styled(Button)({
  width: '60px',
  padding: '4px',
  height: 'fit-content',
});

export const CommentsText = styled(Typography)(({ theme }) => ({
  fontSize: 15,
  color: theme.palette.text.primary,
  display: 'flex',
}));

export const SendCommentsBtn = {
  mr: 1,
  '&.Mui-disabled': {
    color: 'action.disabled',
    background: 'action.disabledBackground',
  },
};

export const SubTitleWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const SyncIconStyle = {
  cursor: 'pointer',
  '&:hover': {
    color: 'info.main',
    transform: 'rotate(90deg)',
    transition: 'all 0.3s ease-in-out',
  },
};

export const modalStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '480px',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  padding: 3,
  borderRadius: '0.5rem',
  display: 'flex',
  gap: 2,
  flexDirection: 'column',
};

export const buttonContainerStyles = {
  display: 'flex',
  gap: 2,
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: 3,
};

export const CenteredGrid = styled(Grid)({
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const GSBStyle = styled('a')(({ theme }) => ({
  marginTop: 2,
  fontSize: '14px',
  color: theme.palette.primary.dark,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

export const GSBLiveInfoTypography = styled(Typography)({
  display: 'flex',
  gap: 4
})

export const MaliciousText = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
}));

export const NoMaliciousText = styled('span')(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

export const SuspiciousText = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const UnknownText = styled('span')(({ theme }) => ({
  color: theme.palette.info.main,
}));

export const BenignText = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const StyledHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '8px', 
}));

export const HorizontalLine = styled(MuiDivider)(({ theme }) => ({
  backgroundColor: theme.palette.border?.main,
}));

export const NotesTitle = styled(Typography)(({ theme }) => ({
  margin: '12px 0px 12px 0px',
  fontWeight: 700,
}));

export const NotesValues = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));
